import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { PaymentOptions } from './PaymentOptions';
import { EnterprisePaymentOptions } from './EnterprisePaymentOptions';
import { PaymentModeSelector } from './PaymentModeSelector';
import { Badge } from '@/components/ui/badge';
import { User, Building2 } from 'lucide-react';

interface PaymentRouterProps {
  courseId: string;
  formationTitle: string;
  price: number;
  currency?: string;
  isCart?: boolean;
  cartItems?: Array<{id: string; title: string; price: number; currency: string}>;
}

export function PaymentRouter(props: PaymentRouterProps) {
  const { userRole, isAdminEntreprise } = useAuth();
  const [showModeSelector, setShowModeSelector] = useState(true);
  
  // Vérifier s'il y a un test mode dans localStorage
  const isTestMode = localStorage.getItem('test-enterprise-mode') === 'true';
  
  // Si l'utilisateur est admin entreprise OU en mode test, afficher les options entreprise
  if (isAdminEntreprise || userRole === 'admin_entreprise' || isTestMode) {
    return (
      <div className="space-y-4">
        <div className="flex items-center justify-center gap-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <Building2 className="h-5 w-5 text-blue-600" />
          <span className="text-sm font-medium text-blue-900">
            Mode Entreprise actif - Tarifs et options spécialisées
          </span>
          {isTestMode && (
            <span className="ml-2 px-2 py-1 bg-orange-100 text-orange-800 text-xs rounded-full">
              TEST
            </span>
          )}
        </div>
        <EnterprisePaymentOptions {...props} />
      </div>
    );
  }

  // Interface simplifiée pour les particuliers
  return <PaymentOptions {...props} />;
}